export default "__VITE_ASSET__Cut7A1jc__"